// src/pages/Cart/CartPage.js
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import './CartPage.css';

// Barème de livraison — identique à celui appliqué côté serveur
// (voir Backend/app/routes/payment_routes.py). Le serveur reste seul juge
// du montant réellement facturé : ces valeurs ne servent qu'à l'affichage.
const FRAIS_LIVRAISON = 4.90;
const SEUIL_LIVRAISON_GRATUITE = 50.0;

export default function CartPage() {
  useDocumentTitle('Mon panier');

  const { items, total, removeItem, updateQty } = useCart();

  const livraisonOfferte   = total >= SEUIL_LIVRAISON_GRATUITE;
  const totalAvecLivraison = total + (livraisonOfferte ? 0 : FRAIS_LIVRAISON);

  return (
    <div className="cart-page">
      <div className="container cart-page__inner">
        <h1 className="cart-page__titre">Mon Panier</h1>
        <hr className="divider-or" style={{ margin: '16px 0 32px' }} />

        {items.length === 0 ? (
          <div className="cart-page__vide">
            <p>Votre panier est vide.</p>
            <Link to="/catalogue" className="btn-or">Découvrir la collection</Link>
          </div>
        ) : (
          <div className="cart-page__layout">

            {/* ── Articles ── */}
            <div className="cart-page__liste">
              {items.map(item => (
                <div key={item.id} className="cart-item">
                  <img
                    className="cart-item__img"
                    src={item.images?.[0] || `https://placehold.co/160x160/1a1a1a/c9a84c?text=${encodeURIComponent(item.nom)}`}
                    alt={item.nom}
                    loading="lazy"
                  />

                  <div className="cart-item__infos">
                    <p className="cart-item__nom">{item.nom}</p>
                    <p className="cart-item__cat">{item.categorie}</p>
                  </div>

                  <div className="cart-item__qte">
                    <button
                      className="cart-item__btn"
                      onClick={() => updateQty(item.id, item.quantite - 1)}
                      disabled={item.quantite <= 1}
                      aria-label={`Retirer un ${item.nom}`}
                    >−</button>
                    <span className="cart-item__nb">{item.quantite}</span>
                    <button
                      className="cart-item__btn"
                      onClick={() => updateQty(item.id, item.quantite + 1)}
                      aria-label={`Ajouter un ${item.nom}`}
                    >+</button>
                  </div>

                  <p className="cart-item__prix">{(item.prix * item.quantite).toFixed(2)} €</p>

                  <button
                    className="cart-item__suppr"
                    onClick={() => removeItem(item.id)}
                    aria-label={`Retirer ${item.nom} du panier`}
                  >×</button>
                </div>
              ))}
            </div>

            {/* ── Récapitulatif ── */}
            <div className="cart-recap">
              <h2 className="cart-recap__titre">Récapitulatif</h2>

              <div className="cart-recap__ligne">
                <span>Sous-total</span><span>{total.toFixed(2)} €</span>
              </div>

              <div className="cart-recap__ligne">
                <span>Livraison</span>
                {livraisonOfferte
                  ? <span className="cart-recap__offerte">Offerte</span>
                  : <span>{FRAIS_LIVRAISON.toFixed(2)} €</span>}
              </div>

              {!livraisonOfferte && (
                <p className="cart-recap__hint">
                  Plus que {(SEUIL_LIVRAISON_GRATUITE - total).toFixed(2)} € pour bénéficier de la livraison offerte.
                </p>
              )}

              <div className="cart-recap__total">
                <span>Total</span>
                <span className="cart-recap__total-valeur">{totalAvecLivraison.toFixed(2)} €</span>
              </div>

              <Link to="/checkout" className="btn-or cart-recap__cta">Passer la commande</Link>
              <Link to="/catalogue" className="cart-recap__retour">← Continuer les achats</Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
